import React from 'react';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const SpeciesCard = ({ species, onClick }) => {
  const getThreatColor = (level) => {
    const colors = {
      'Critical': 'bg-error text-error-foreground',
      'Endangered': 'bg-warning text-warning-foreground',
      'Vulnerable': 'bg-accent text-accent-foreground',
      'Stable': 'bg-success text-success-foreground'
    };
    return colors?.[level] || 'bg-muted text-muted-foreground';
  };

  const getTrendIcon = (trend) => {
    const icons = {
      'increasing': { name: 'TrendingUp', color: 'text-success' },
      'stable': { name: 'Minus', color: 'text-muted-foreground' },
      'decreasing': { name: 'TrendingDown', color: 'text-error' }
    };
    return icons?.[trend] || icons?.stable;
  };

  const trendIcon = getTrendIcon(species?.populationTrend);

  return (
    <div 
      onClick={onClick}
      className="bg-[var(--color-card)] rounded-lg overflow-hidden shadow-conservation hover:shadow-conservation-lg animation-organic cursor-pointer group border border-[var(--color-border)]"
    >
      <div className="relative h-48 overflow-hidden">
        <Image
          src={species?.image}
          alt={species?.imageAlt}
          className="w-full h-full object-contain group-hover:scale-105 animation-organic"
        />
        <div className={`absolute top-3 right-3 px-3 py-1 rounded-full text-xs font-medium ${getThreatColor(species?.threatLevel)}`}>
          {species?.threatLevel}
        </div>
      </div>
      <div className="p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex-1">
            <h3 className="text-base font-semibold text-[var(--color-foreground)] mb-1">{species?.commonName}</h3>
            <p className="text-xs italic text-[var(--color-muted-foreground)]">{species?.scientificName}</p>
          </div>
          <Icon 
            name={trendIcon?.name} 
            size={20} 
            className={trendIcon?.color}
          />
        </div>

        <p className="text-sm text-[var(--color-muted-foreground)] mb-4 line-clamp-2">{species?.description}</p>

        <div className="grid grid-cols-2 gap-3 mt-4">
          <div>
            <p className="text-xs text-[var(--color-muted-foreground)] mb-1">Population</p>
            <p className="text-sm font-medium text-[var(--color-foreground)]">{species?.population}</p>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="TrendingUp" size={16} className="text-success" />
            <div>
              <p className="text-xs text-[var(--color-muted-foreground)]">Trend</p>
              <p className="text-sm font-medium text-[var(--color-foreground)]">{species?.trend}</p>
            </div>
          </div>
        </div>

        <div className="mt-3 pt-3 border-t border-border">
          <p className="text-xs text-[var(--color-muted-foreground)]">Primary Threat</p>
          <p className="text-sm text-[var(--color-foreground)] mt-1">{species?.primaryThreat}</p>
        </div>
      </div>
    </div>
  );
};

export default SpeciesCard;